import { createSlice } from '@reduxjs/toolkit';

const breadCrumbs = createSlice({
  name: 'breadcrumbs',
  initialState: {
    title: '',
    subtitle: '',
    idType: '',
    accordeonMotiveOpen: '',
  },
  reducers: {
    setTitle(state, action) {
      state.title = action.payload;
    },
    setSubtitle(state, action) {
      state.subtitle = action.payload;
    },
    setIdType(state, action) {
      state.idType = action.payload;
    },
    setAccordeonMotiveOpen(state, action) {
      state.accordeonMotiveOpen = action.payload;
    },
  },
});

export const {
  setTitle,
  setSubtitle,
  setIdType,
  setAccordeonMotiveOpen,
} = breadCrumbs.actions;
export default breadCrumbs.reducer;
